module.exports = __webpack_public_path__ + "static/media/saintDo.8f14f27f.jpg";